import Player from '@vimeo/player'

/**
 * @param autoPlay
 * @param hoverPlay
 * @param playMs How long to wait before playing the video
 * @param hideMs How long to wait before hiding the foreground
 */
export default (autoPlay = true, hoverPlay = false, playMs = 1500, hideMs = 500) => {
    return {
        wrapper: null,
        iframe: null,
        player: null,
        playButton: null,
        hideForeground: false,
        init () {
            this.$nextTick(() => {
                this.wrapper = this.$el.querySelector('.vimeo-wrapper')
                this.initIframe()
                this.initPlayer()
            })
        },
        initIframe () {
            this.iframe = this.wrapper.querySelector('iframe')

            if (this.iframe || typeof this.wrapper.dataset.iframe === 'undefined') {
                console.log('skip')
                return
            }

            let iframeAttributes = JSON.parse(this.wrapper.dataset.iframe)
            this.iframe = document.createElement('iframe')

            for (let key in iframeAttributes) {
                if (iframeAttributes.hasOwnProperty(key)) {
                    this.iframe.setAttribute(key, iframeAttributes[key])
                }
            }

            this.wrapper.appendChild(this.iframe)
        },
        initPlayer () {
            let player = new Player(this.iframe)

                player.ready().then(() => {
                    setTimeout(() => {
                        if (autoPlay && !hoverPlay) {
                            player.play()
                        } else {
                            this.hideForeground = true
                        }
                    }, playMs)
                })

            player.on('play', () => {
                setTimeout(() => {
                    this.hideForeground = true
                }, hideMs)
            })

            this.player = player
            this.playButton = this.$el.querySelector('button')

            if (this.playButton) {
                this.playButton.addEventListener('click', () => {
                    player.setMuted(false)
                    player.requestFullscreen()

                    if (!autoPlay) {
                        player.play()
                    }
                })

                document.addEventListener('fullscreenchange', (event) => {
                    if (event.target !== this.iframe || document.fullscreenElement) {
                        return
                    }

                    player.setMuted(true)

                    if (!autoPlay) {
                        player.pause()
                    }
                })
            }

            if (hoverPlay) {
                this.$el.addEventListener('mouseenter', () => {
                    player.play()
                })

                this.$el.addEventListener('mouseleave', () => {
                    player.pause()
                })
            }
        }
    }
}

